import { auth, db } from '../../firebase.js';
import { doc, getDocs, collection } from 'firebase/firestore';
import { ProfilePage } from './ProfilePage.js';

export class AuthorProfile extends ProfilePage{
    constructor(uid){
        super(uid);
        // this.user = user;
        this.userData = null;
        this.uid = uid;
        this.role = 'author';
        this.publishedBooks = null;
        this.publishedBooksLength = null;
    }
    getPublishedBooks(){
        console.log("Published books list: ",this.publishedBooks);
        return this.publishedBooks;
    }
    getPublishedBooksLength(){
        console.log("Number of books published: ",this.publishedBooksLength);
        return this.publishedBooksLength;
    }
    setPublishedBooks = async () => {
        // console.log(user.uid);
        try {
          const querySnapshot = await getDocs(
            collection(db, "users", this.uid, "publishedBooks")
          );
          const books = querySnapshot.docs.map((doc) => doc.data());
          
          console.log("publishedbooks from class: ",books);
          this.publishedBooks = books;
          console.log("publishedbooks from class: ",this.publishedBooks);

          this.publishedBooksLength = books.length;
          console.log("publishedbooks length from class: ",this.publishedBooksLength);
      
        } catch (error) {
          console.error("Error getting documents: ", error);
          return false;
        }
      };

      setAuthorData = (data) =>{
        this.username = data.username;
        this.pronouns = data.pronouns;
        this.following = data.following;
        this.followers = data.followers;
        this.bio = data.bio;
        this.publishedBooks = data.publishedBooks;
        if (this.publishedBooks == null) this.publishedBooksLength = 0;
        else this.publishedBooksLength = this.publishedBooks.length;
        this.followersCount = data.followers?.length || 0;
        this.followingCount = data.following?.length || 0;
      }

      getRole = () =>{
        return this.role;
      }
      getPublishedBooks = () =>{
        if (this.publishedBooksLength > 0) return this.publishedBooks;
        else throw new Error("No published books found. Check if new Author.");
      }
      getISBN = (index) =>{
        return this.publishedBooks[index].isbn;
      }
}